import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateLinkStatus = createAsyncThunk('updateLinkStatus/updateLinkStatus', async (data) => {
    const { id, status } = data;
    try {
        const res = await axios({
            method: 'PUT',
            url: process.env.REACT_APP_API_URL + `update_link_status/${id}`,
            data: {
                status: status
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

